import type { ManagerialDashboardActiveCampaign } from '@/types/api'
import { formatFullCurrencyBrl, formatIntegerBr } from './managerial-kpis'

export type ActiveCampaignStatus = 'active'

export type ActiveCampaignView = {
  id: string
  title: string
  prizeLabel: string
  drawLabel: string
  status: ActiveCampaignStatus
  statusLabel: string
  imageUrl: string | null
  initials: string
  formattedNumbers: string
  formattedRevenue: string
}

export const ACTIVE_CAMPAIGN_STATUS_LABELS: Record<ActiveCampaignStatus, string> = {
  active: 'Ativa',
}

export const EMPTY_ACTIVE_CAMPAIGN_VIEWS: ActiveCampaignView[] = []

function formatDrawLabel(drawDate: string | null): string {
  if (drawDate === null) {
    return 'Sorteio: data não definida'
  }

  const [year, month, day] = drawDate.split('-')
  if (!day || !month || !year) {
    return `Sorteio: ${drawDate}`
  }

  return `Sorteio: ${day}/${month}/${year}`
}

function resolveInitials(title: string): string {
  const first = title.trim().charAt(0)
  return first !== '' ? first.toUpperCase() : 'C'
}

/**
 * A API só devolve campanha ativa com venda paga. Sem venda não entra.
 */
export function mapActiveCampaigns(
  campaigns: ManagerialDashboardActiveCampaign[]
): ActiveCampaignView[] {
  return campaigns.map((campaign) => ({
    id: String(campaign.id),
    title: campaign.title,
    prizeLabel:
      campaign.prize_label !== '' ? `Prêmios: ${campaign.prize_label}` : 'Prêmios: —',
    drawLabel: formatDrawLabel(campaign.draw_date),
    status: 'active',
    statusLabel: ACTIVE_CAMPAIGN_STATUS_LABELS.active,
    imageUrl: campaign.image_url,
    initials: resolveInitials(campaign.title),
    formattedNumbers: formatIntegerBr(campaign.sold_numbers),
    formattedRevenue: formatFullCurrencyBrl(campaign.revenue),
  }))
}
